import {Component, Input, OnInit} from '@angular/core';
import {User} from '@modules/administration/users/interfaces/user.model';
import {UserConstant} from '@modules/administration/users/user.constant';
import {RoleTypes} from '@modules/administration/administration.const';
import {SysDateFormat} from '@core/constant/system.constants';
@Component({
  selector: 'app-view-user',
  templateUrl: './view-user.component.html',
  styleUrls: ['./view-user.component.css']
})
export class ViewUserComponent implements OnInit {
  @Input() user: User;

  readonly userStatus = UserConstant.USER_STATUS;
  readonly userRoleTypes = RoleTypes;
  readonly SysDateFormat = SysDateFormat;

  constructor() { }

  ngOnInit(): void {
  }

}
